import { EditorInstance, RichTextEditorState } from './types'

export const initialEditorInstance: EditorInstance = {
  linkBubble: null,
  linkInputValue: '',
}

export const initialRichTextEditorState: RichTextEditorState = {
  editors: {},
}
